export default __webpack_public_path__ + "static/media/down-lite.fb690bbc.svg";